export default "__VITE_ASSET__1gbwA7LI__"